export default __webpack_public_path__ + "static/media/113.7f90050e.gif";